import { compact, map } from "lodash";

export default function classes(conditionals, ...rest) {
  return [
    ...compact(map(conditionals, (use, name) => (use ? name : ""))),
    ...rest,
  ].join(" ");
}
